// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"84916d34","455":"fe132802","977":"0fd6cc89"}[chunkId] + ".chunk.js";
};